import React from 'react';
import { observer } from 'mobx-react';
import clsx from 'clsx';
import PropTypes from 'prop-types';

import RatingImgViewModel from './viewModel';

import styles from './styles.module.css';

@observer
class RatingImg extends React.Component {
  constructor(props) {
    super(props);

    this.viewModel = new RatingImgViewModel(this.props.disabled);
  }

  render() {
    const { stars, onClick, disabled, size } = this.props;
    const { isPointAt, onMouseEnter, onMouseLeave } = this.viewModel;
    return (
      <div
        className={styles.starsContainer}
        onMouseLeave={() => onMouseLeave()}
      >
        <div
          className={clsx(
            styles.stars,
            disabled && styles.disabled,
            isPointAt === 0 && stars >= 1 ? styles.yellowStar : styles.grayStar,
            isPointAt && isPointAt >= 1 && styles.yellowStar
          )}
          style={{
            width: size,
            height: size
          }}
          onClick={() => onClick(1)}
          onMouseEnter={() => onMouseEnter(1)}
        />
        <div
          className={clsx(
            styles.stars,
            disabled && styles.disabled,
            isPointAt === 0 && stars >= 2 ? styles.yellowStar : styles.grayStar,
            isPointAt && isPointAt >= 2 && styles.yellowStar
          )}
          style={{
            width: size,
            height: size
          }}
          onClick={() => onClick(2)}
          onMouseEnter={() => onMouseEnter(2)}
        />
        <div
          className={clsx(
            styles.stars,
            disabled && styles.disabled,
            isPointAt === 0 && stars >= 3 ? styles.yellowStar : styles.grayStar,
            isPointAt && isPointAt >= 3 && styles.yellowStar
          )}
          style={{
            width: size,
            height: size
          }}
          onClick={() => onClick(3)}
          onMouseEnter={() => onMouseEnter(3)}
        />
        <div
          className={clsx(
            styles.stars,
            disabled && styles.disabled,
            isPointAt === 0 && stars >= 4 ? styles.yellowStar : styles.grayStar,
            isPointAt && isPointAt >= 4 && styles.yellowStar
          )}
          style={{
            width: size,
            height: size
          }}
          onClick={() => onClick(4)}
          onMouseEnter={() => onMouseEnter(4)}
        />
        <div
          className={clsx(
            styles.stars,
            disabled && styles.disabled,
            isPointAt === 0 && stars >= 5 ? styles.yellowStar : styles.grayStar,
            isPointAt && isPointAt >= 5 && styles.yellowStar
          )}
          style={{
            width: size,
            height: size
          }}
          onClick={() => onClick(5)}
          onMouseEnter={() => onMouseEnter(5)}
        />
      </div>
    );
  }
}

RatingImg.propTypes = {
  stars: PropTypes.number,
  onClick: PropTypes.func,
  disabled: PropTypes.bool,
  size: PropTypes.number
};

RatingImg.defaultProps = {
  stars: 0,
  onClick: () => { },
  disabled: false,
  size: 20
};

export default RatingImg;
